// extracted by mini-css-extract-plugin
export var fadeInAnimation = "numberedlist-module--fadeInAnimation--725a3";
export var list = "numberedlist-module--list--595fb";
export var listItem = "numberedlist-module--listItem--1acfa";
export var subtitle = "numberedlist-module--subtitle--5fab4";
export var title = "numberedlist-module--title--4cee5";
export var wrapper = "numberedlist-module--wrapper--c8736";